import React from 'react';
import { motion } from 'framer-motion';
import { VideoIcon, DatabaseIcon, RefreshCwIcon, CheckIcon, ZapIcon, CheckCircle2Icon } from 'lucide-react';
export function Hero() {
  const CYCLE_DURATION = 3;
  return <section className="relative min-h-screen pt-24 pb-12 overflow-hidden bg-slate-50 flex flex-col justify-center" data-id="element-139" data-mp="9ll8uwe5pwmz">
      {/* Subtle dot grid background */}
      <div className="absolute inset-0 z-0 opacity-50 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#94a3b8 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-140" data-mp="1297cu5rar3ad" />

      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10" data-id="element-141" data-mp="sa9n4zi4x3ps">
        {/* Headline + Sub-headline */}
        <div className="text-center max-w-3xl mx-auto" data-id="element-142" data-mp="nbosrgpkde99">
          {/* Beta Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-teal-200 bg-teal-50 text-xs font-medium text-teal-700 mb-4" data-id="element-143" data-mp="3d2birmcv0tty">
            <div className="w-1.5 h-1.5 rounded-full bg-teal-500" data-id="element-144" data-mp="3e9fqzbok84l5" />
            Early Access · Beta
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="text-5xl md:text-6xl lg:text-7xl font-medium text-slate-900 tracking-tight mb-6 text-balance leading-[1.1]" data-id="element-145" data-mp="30hrgtdxvfq6t">
            Eliminate <br data-id="element-146" data-mp="2hjyot6osd0o7" />
            <span className="text-teal-600" data-id="element-147" data-mp="2hlj7nz1qmv68">post-sales-call admin.</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.25
        }} className="text-lg text-slate-600 font-normal mb-0 max-w-2xl mx-auto leading-relaxed" data-id="element-148" data-mp="2lmuyu909fogj">
            Kinase extracts qualification data and next steps from your Zoom
            recordings and syncs everything to HubSpot, automatically.
          </motion.p>
        </div>

        {/* Pipeline Flow Diagram */}
        <div className="mt-10 lg:mt-12 mb-10 lg:mb-12" data-id="element-149" data-mp="112pur23hu6ar">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-0 relative" data-id="element-150" data-mp="11150ldl3cpdf">
            {/* Radial teal glow behind the center */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-teal-200/30 rounded-full blur-3xl z-0 pointer-events-none hidden md:block" data-id="element-151" data-mp="3ltgmzq8oqqoc" />

            {/* Left group: card + line */}
            <div className="hidden md:flex w-[416px] items-center justify-end relative z-10" data-id="element-152" data-mp="1xacj1d51o1xz">
              <motion.div initial={{
              opacity: 0,
              x: -30
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="bg-white border border-slate-200 p-4 rounded-xl flex items-center gap-4 w-64 shadow-md" data-id="element-153" data-mp="21bxy9551wsbc">
                <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-154" data-mp="2p0qqormgsi17">
                  <VideoIcon className="w-5 h-5 text-blue-500" data-id="element-155" data-mp="2tztw4d6cwq9p" />
                </div>
                <div data-id="element-156" data-mp="umzgnr083w58">
                  <div className="text-sm font-semibold text-slate-900" data-id="element-157" data-mp="unizrb1m0qku">
                    Zoom Recording
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-158" data-mp="zlstriblll4v">
                    Vantage Systems · 42m
                  </div>
                </div>
              </motion.div>
              <motion.svg initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 0.5,
              delay: 0.5
            }} className="w-24 h-8 flex-shrink-0" viewBox="0 0 96 8" fill="none" data-id="element-159" data-mp="3vgvtghnpyx0z">
                <line x1="0" y1="4" x2="96" y2="4" stroke="#cbd5e1" strokeWidth="1.5" data-id="element-160" data-mp="3ct0lxfipafgb" />
                <motion.circle r="3" fill="#2dd4bf" cy="4" animate={{
                cx: [0, 96]
              }} transition={{
                duration: CYCLE_DURATION,
                repeat: Infinity,
                ease: 'linear'
              }} data-id="element-161" data-mp="3mnagn3v47pu7" />
              </motion.svg>
            </div>

            {/* Mobile-only: Zoom card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="md:hidden relative z-10" data-id="element-162" data-mp="zm2dlg9c5fvs">
              <div className="bg-white border border-slate-200 p-4 rounded-xl flex items-center gap-4 w-64 shadow-md" data-id="element-163" data-mp="1j7f7g0v4cv6b">
                <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-164" data-mp="1n8h7ul0rvd9v">
                  <VideoIcon className="w-5 h-5 text-blue-500" data-id="element-165" data-mp="7s0dz724clfy" />
                </div>
                <div data-id="element-166" data-mp="bwgfkw4p96pd">
                  <div className="text-sm font-semibold text-slate-900" data-id="element-167" data-mp="bsk7m0nhh6xc">
                    Zoom Recording
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-168" data-mp="29hxsa8wyhspl">
                    Vantage Systems · 42m
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Center: Kinase Circle */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.6
          }} className="relative z-10 w-32 h-32 bg-white border-2 border-teal-200 rounded-full flex flex-col items-center justify-center shadow-lg flex-shrink-0" data-id="element-169" data-mp="1zrwfida1zwpz">
              <motion.div animate={{
              rotate: 360
            }} transition={{
              duration: CYCLE_DURATION,
              repeat: Infinity,
              ease: 'linear',
              delay: 0.6 // Start spinning after it appears
            }} data-id="element-170" data-mp="3g5mn3u0dt34d">
                <RefreshCwIcon className="w-7 h-7 text-teal-500" data-id="element-171" data-mp="3sh5dgds0yrjk" />
              </motion.div>
              <span className="text-[10px] font-bold text-teal-600 tracking-wider mt-1.5" data-id="element-172" data-mp="1auld74zt14d">
                KINASE
              </span>
            </motion.div>

            {/* Right group: line + card */}
            <div className="hidden md:flex w-[416px] items-center justify-start relative z-10" data-id="element-173" data-mp="34rky04v2ycf1">
              <motion.svg initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 0.5,
              delay: 0.8
            }} className="w-24 h-8 flex-shrink-0" viewBox="0 0 96 8" fill="none" data-id="element-174" data-mp="39qnrcs1p6u76">
                <line x1="0" y1="4" x2="96" y2="4" stroke="#cbd5e1" strokeWidth="1.5" data-id="element-175" data-mp="1f32cocn9y3fr" />
                <motion.circle r="3" fill="#f97316" cy="4" animate={{
                cx: [0, 96]
              }} transition={{
                duration: CYCLE_DURATION,
                repeat: Infinity,
                ease: 'linear'
              }} data-id="element-176" data-mp="1otnavyz1d5y5" />
              </motion.svg>
              <motion.div initial={{
              opacity: 0,
              x: 30
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5,
              delay: 0.9
            }} className="bg-white border border-slate-200 p-5 rounded-xl w-80 shadow-md" data-id="element-177" data-mp="27qy71apdfj9d">
                <div className="flex items-center gap-3 mb-4 pb-3 border-b border-slate-100" data-id="element-178" data-mp="2p1k7htbuq43e">
                  <div className="w-10 h-10 bg-orange-50 rounded-lg flex items-center justify-center" data-id="element-179" data-mp="2p3ehicll4bsp">
                    <DatabaseIcon className="w-5 h-5 text-orange-500" data-id="element-180" data-mp="2fbqxgwrcxx19" />
                  </div>
                  <div data-id="element-181" data-mp="2f9e83yj9ske6">
                    <div className="text-sm font-semibold text-slate-900" data-id="element-182" data-mp="21bg33jqua0bc">
                      Vantage Systems
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-183" data-mp="26cnb9jww91ij">
                      HubSpot Deal Updated
                    </div>
                  </div>
                </div>
                <div className="space-y-2.5" data-id="element-184" data-mp="1wc4nwf64f2vv">
                  <div className="text-[10px] uppercase tracking-wider text-slate-400 font-medium" data-id="element-185" data-mp="1wez6s29hkfn6">
                    Qualification Data
                  </div>
                  {[{
                  label: 'Budget',
                  value: '$75,000'
                }, {
                  label: 'Authority',
                  value: 'VP Engineering'
                }, {
                  label: 'Need',
                  value: 'Platform migration'
                }, {
                  label: 'Timeline',
                  value: 'Q3 Implementation'
                }].map((item, i) => <div key={i} className="flex items-center justify-between" data-id="element-186" data-mp="ysemsk85nuzl" data-mpi={i}>
                      <span className="text-xs text-slate-500" data-id="element-187" data-mp="ku7vjmxpot8w">
                        {item.label}
                      </span>
                      <span className="text-xs font-medium text-slate-900" data-id="element-188" data-mp="otyu4cthcdnz">
                        {item.value}
                      </span>
                    </div>)}
                  <div className="h-px bg-slate-100 my-1" data-id="element-189" data-mp="39mk64by7ik42" />
                  <div className="text-[10px] uppercase tracking-wider text-slate-400 font-medium" data-id="element-190" data-mp="321zu4m7zrjph">
                    Next Steps
                  </div>
                  <div className="flex items-center gap-2" data-id="element-191" data-mp="2x23rorey00c1">
                    <CheckCircle2Icon className="w-3.5 h-3.5 text-teal-500 flex-shrink-0" data-id="element-192" data-mp="3c0pd6ibmja7b" />
                    <span className="text-xs text-slate-700" data-id="element-193" data-mp="371cff2j7sipy">
                      Schedule Technical Review
                    </span>
                  </div>
                </div>
              </motion.div>
            </div>

            {/* Mobile-only: HubSpot card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.9
          }} className="md:hidden relative z-10" data-id="element-194" data-mp="2eaax4sk86727">
              <div className="bg-white border border-slate-200 p-5 rounded-xl w-80 shadow-md" data-id="element-195" data-mp="1vleb1byzekv2">
                <div className="flex items-center gap-3 mb-4 pb-3 border-b border-slate-100" data-id="element-196" data-mp="2l9jsif0okbbh">
                  <div className="w-10 h-10 bg-orange-50 rounded-lg flex items-center justify-center" data-id="element-197" data-mp="2pac073twm85n">
                    <DatabaseIcon className="w-5 h-5 text-orange-500" data-id="element-198" data-mp="2u2wu05ct8l96" />
                  </div>
                  <div data-id="element-199" data-mp="2z053zint1izc">
                    <div className="text-sm font-semibold text-slate-900" data-id="element-200" data-mp="2z3kgqeu0afxl">
                      Vantage Systems
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-201" data-mp="26c98gh9z1x45">
                      HubSpot Deal Updated
                    </div>
                  </div>
                </div>
                <div className="space-y-2.5" data-id="element-202" data-mp="2be88bh6i6bwc">
                  <div className="text-[10px] uppercase tracking-wider text-slate-400 font-medium" data-id="element-203" data-mp="2gbzzua38jw00">
                    Qualification Data
                  </div>
                  {[{
                  label: 'Budget',
                  value: '$75,000'
                }, {
                  label: 'Authority',
                  value: 'VP Engineering'
                }, {
                  label: 'Need',
                  value: 'Platform migration'
                }, {
                  label: 'Timeline',
                  value: 'Q3 Implementation'
                }].map((item, i) => <div key={i} className="flex items-center justify-between" data-id="element-204" data-mp="sd7ejrh9girq" data-mpi={i}>
                      <span className="text-xs text-slate-500" data-id="element-205" data-mp="sfadx24azo94">
                        {item.label}
                      </span>
                      <span className="text-xs font-medium text-slate-900" data-id="element-206" data-mp="if9qb3zeilz4">
                        {item.value}
                      </span>
                    </div>)}
                  <div className="h-px bg-slate-100 my-1" data-id="element-207" data-mp="2ct1agxfcwo8t" />
                  <div className="text-[10px] uppercase tracking-wider text-slate-400 font-medium" data-id="element-208" data-mp="2ctkhhj3gxs82">
                    Next Steps
                  </div>
                  <div className="flex items-center gap-2" data-id="element-209" data-mp="2psjye7p5tsro">
                    <CheckCircle2Icon className="w-3.5 h-3.5 text-teal-500 flex-shrink-0" data-id="element-210" data-mp="2pqqz5dgvmatp" />
                    <span className="text-xs text-slate-700" data-id="element-211" data-mp="2avb0sw99jsri">
                      Schedule Technical Review
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* CTA + Trust Badges */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 1.1 // Adjusted delay to follow the diagram animation
      }} className="text-center" data-id="element-212" data-mp="26vip4aokp6hx">
          <div className="flex items-center justify-center mb-8" data-id="element-213" data-mp="1n5qdk162u9cf">
            <a href="https://app.getkinase.com" className="px-6 py-3 bg-teal-500 hover:bg-teal-400 text-white rounded-lg font-medium text-base transition-colors flex items-center justify-center space-x-2 shadow-sm shadow-teal-500/20" data-id="element-214" data-mp="1n82ss6kga5ls">
              <ZapIcon className="w-4 h-4" data-id="element-215" data-mp="1djxjihbtrqdk" />
              <span data-id="element-216" data-mp="18jjb2y6baef0">Request free early access</span>
            </a>
          </div>

          <div className="flex items-center justify-center space-x-5 text-sm text-slate-500" data-id="element-217" data-mp="18lm9o6lj5fvc">
            <div className="flex items-center" data-id="element-218" data-mp="1ne7du4kbuyqx">
              <CheckIcon className="w-4 h-4 mr-1.5 text-teal-500" data-id="element-219" data-mp="1ige97fyoacsr" />
              <span data-id="element-220" data-mp="1w8m2uyuntnn8">Free during beta</span>
            </div>
            <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-221" data-mp="1w82k5fx6qv85"></span>
            <div className="flex items-center" data-id="element-222" data-mp="1s8bl6oxi98sj">
              <CheckIcon className="w-4 h-4 mr-1.5 text-teal-500" data-id="element-223" data-mp="1s9mpcpuv4ik6" />
              <span data-id="element-224" data-mp="267jn3pl1yv0f">No credit card</span>
            </div>
            <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-225" data-mp="218gu53ickf8t"></span>
            <div className="flex items-center" data-id="element-226" data-mp="21640vu752igg">
              <CheckIcon className="w-4 h-4 mr-1.5 text-teal-500" data-id="element-227" data-mp="yvkb155oc90l" />
              <span data-id="element-228" data-mp="12vuqd8fcwbs4">Setup in minutes</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}